var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStickerFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 17.8667V6.13333C4 4.95513 4.95513 4 6.13333 4H17.8667C19.0449 4 20 4.95513 20 6.13333V12.5333H16.8C14.7381 12.5333 13.0667 14.2048 13.0667 16.2667V20H6.13333C4.95513 20 4 19.0449 4 17.8667Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9695 13.6H16.8C15.3272 13.6 14.1333 14.7939 14.1333 16.2667V20H14.1752L19.9695 13.6Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickerFill);
export default __webpack_public_path__ + "static/media/sticker_fill.104882381e601850fb153bdfd523910f.svg";
export { ForwardRef as ReactComponent };